import React, { ReactNode, useEffect, useState } from "react";
import { TokenProps } from "../models/theme";
import { AuthContext } from "../context/authContext";
import { useQueryAuth } from "../api/queries";
import { ErrorPage } from "../shared";
import { isErrorResponse } from "../utils";
import { Loading } from "../components";

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<TokenProps | null>(null);

  const { data, isLoading: isLoadingAuth, isError, error } = useQueryAuth({});

  useEffect(() => {
    updateToken({ access_token: data?.access_token });
  }, [data]);

  /* eslint-disable */
  const updateToken = (data: any) => {
    const value = { ...data };
    localStorage.setItem("authStorage", data.access_token);
    setToken(value);
  };

  const value = React.useMemo(
    () => ({
      token,
      updateToken,
    }),
    [token]
  );

  if (isLoadingAuth) return <Loading />;

  if (isErrorResponse(data) || isError || !!error) {
    return <ErrorPage />;
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
